import ResourceManager from "../Managers/ResourceManager";
class StatusBox {
    public statusBox: HTMLDivElement;
    public progressContainer: HTMLDivElement;
    public progressBar: HTMLDivElement;
    public progressBarText: HTMLDivElement;
    public progress: HTMLDivElement;
    public progressPercentage: HTMLDivElement;

    private centerOnParent: boolean = false;
    public progressBarBaseText: string;
    constructor(container: HTMLDivElement, centerBarOnParent: boolean) {
        this.centerOnParent = centerBarOnParent;
        this._createStatusBox(container);
    }

    public createProgressBar = () => {
        this.progressBarBaseText = ResourceManager.getString("3D.RetrievingData");
        this.progressBar = this._addDiv(this.progressContainer, "vs-progress-bar");
        this.progressBarText = this._addDiv(this.progressBar, "vs-loading-text", this.progressBarBaseText);
        this.progress = this._addDiv(this.progressBar, "vs-progress-status");
    }

    public hide = () => {
        this.progressContainer.style.display = 'none';
    }

    public show = () => {
        this.progressContainer.style.display = '';
    }

    public updateProgress = (percentage: string) => {
        this.progress.style.width = percentage;
        this.progressBarText.innerHTML = this.progressBarBaseText + " " + percentage;
    }

    public showIndeterminate = (text: string) => {
        this.progressBarBaseText = text;
        this.progress.style.width = "0%";
        this.progressBarText.innerHTML = text;
        this.show();
    }

    public setTopPosition(top: string) {
        if (top) {
            this.statusBox.style.top = top;
        }
    }

    private _createStatusBox = (container: HTMLDivElement) => {
        this.statusBox = this._addDiv(container, "vs-main-status");
        
        if (this.centerOnParent) {
            this.statusBox.style.position = 'absolute';
            this.statusBox.style.width = '100%';
            this.statusBox.style.height = '100%';
            this.statusBox.style.left = '0';
            this.statusBox.style.top = '0';
            this.statusBox.style.margin = "0 auto";

            this.progressContainer = this.statusBox;
        }
        else {
            this.statusBox.style.top = '5vh';
            this._createProgressContainer(this.statusBox);
        }
        
    }

    private _createProgressContainer = (container: HTMLDivElement) => {
        this.progressContainer = this._addDiv(container, "vs-main-status-ctnt");
    }

    private _addDiv = (parentContainer: HTMLElement, className: string, text?: string) => {
        var div = document.createElement("div");
        div.className = className;
        if (text) {
            div.innerHTML = text;
        }
        parentContainer.appendChild(div);
        return div;
    }
}

export default StatusBox;
